import { useQuery } from '@tanstack/react-query';
import { getLineItems } from 'utils/OrderWebAPIUtils';
export function useOrderVendorLineItems(orderId, options = {}) {
    var _a;
    return useQuery(['order-vendor-lines', orderId], async () => {
        var _a, _b;
        if (!orderId)
            return [];
        const response = await getLineItems(orderId, {
            line_item_type: 'vendor_payables',
            per_page: 100,
            page: 1,
        });
        return (_b = (_a = response === null || response === void 0 ? void 0 : response.entity) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [];
    }, {
        enabled: options.enabled === undefined
            ? Boolean(orderId)
            : Boolean(options.enabled) && Boolean(orderId),
        staleTime: 30000,
        refetchOnMount: (_a = options.refetchOnMount) !== null && _a !== void 0 ? _a : 'always',
    });
}
